import {checkValid} from "./functions/ModelsValidate";
import _ from "lodash";

export function ClientComments() {

  this.checkValid = checkValid

  this.data = {
    userId: '',
    userName: '',
    comments: [],
    txt: '',
    category: '',
  }

  this.validation = {
    txt: false,
    category: false,
  }

  this.validationTranslate = {
    txt: '',
    category: '',
  }

  this.validationTxt = {
    txt: false,
    category: false,
  }

  /**
   * Getters
   */
  this.getUserId = () => {
    return this.data.userId
  }
  this.getUserName = () => {
    return this.data.userName
  }
  this.getComments = () => {
    return this.data.comments
  }
  this.getTxt = () => {
    return this.data.txt
  }
  this.getCategory = () => {
    return this.data.category
  }

  /**
   * Setters
   */
  this.setUserId = (val) => {
    this.data.userId = val
  }
  this.setUserName = (val) => {
    this.data.userName = val
  }
  this.setComments = (val) => {
    this.data.comments = val
  }
  this.setTxt = (val) => {
    this.data.txt = val
  }
  this.setCategory = (val) => {
    this.data.category = val
  }

}

/**
 * Global Setters
 */

ClientComments.prototype.setItem = function(user, comments) {
  let userInformation = user?.contacts ? _.first(user?.contacts) : user?.user_personal_contact

  this.setUserId(user?.id ? user.id : '')
  this.setUserName(userInformation?.user_full_name ? userInformation.user_full_name : '')
  this.setComments(Array.isArray(comments) ? comments : [])
}

ClientComments.prototype.addComment = function(comment) {
  this.data.comments.unshift(comment)
}

ClientComments.prototype.removeComment = function(id) {
  this.data.comments = this.data.comments.filter(item => item.id !== id)
}

/**
 * Global Getters
 */

ClientComments.prototype.getLastComment = function() {
  return this.data.comments.length > 0 ? this.data.comments[0] : null
}

ClientComments.prototype.getCount = function() {
  return this.data.comments.length
}


/**
 * Validations
 */

ClientComments.prototype.txtValidate = function() {

  let validationItems = {
    txt: this.getTxt(),
    category: this.getCategory(),
  }

  let validationOptions = {
    txt: {type: ['empty']},
    category: {type: ['empty']},
  }

  return this.checkValid(validationItems, validationOptions)
}


/**
 * Prepare Data
 */

ClientComments.prototype.prepareSave = function() {
  return {
    user_id: this.getUserId(),
    comment: this.getTxt(),
    category: this.getCategory(),
  }
}
